import { Checkbox } from "components/Checkbox";
import { Recipe } from "services/recipes";

export const columns = (onHeaderClick: (accessor: string) => void) => [
  {
    Header: "Title",
    accessor: "title",
    onHeaderClick: () => onHeaderClick("title"),
  },
  {
    Header: "Category",
    accessor: "category.name",
    onHeaderClick: () => onHeaderClick("category.name"),
  },
  {
    Header: "Slug",
    accessor: "slug",
    onHeaderClick: () => onHeaderClick("slug"),
  },
  {
    Header: "Published",
    headerClassName: "w-10",
    cellClassName: "text-center",
    Cell: ({ row: { original } }: { row: { original: Recipe } }) => (
      <Checkbox name="published" checked={original.published} disabled />
    ),
    onHeaderClick: () => onHeaderClick("published"),
  },
];
